import Link from "next/link";
import { type ReactNode } from "react";

function TabNavRoot({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <nav className={`flex items-center gap-4 border-b ${className ?? ""}`}>
      {children}
    </nav>
  );
}

function TabNavLink({
  href,
  active,
  children,
  className,
}: {
  href: string;
  active?: boolean;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Link
      href={href}
      className={`relative select-none rounded-t-lg p-2 text-lg outline-none ${active ? "font-semibold text-primary after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:bg-primary" : "hoverable text-muted"} ${className ?? ""}`}
    >
      {children}
    </Link>
  );
}

export const TabNav = {
  Root: TabNavRoot,
  Link: TabNavLink,
};
